<template>
  <!-- 合肥专业律师 -->
    <div class="major_lawyer text_center">
     <div class="flex between">
     	<sec-title
     	  ac-text="合肥"
     	  Text="专业律师"
     	  desc-text="术业有专攻，快速找到与问题相关的律师"
     			:showmore = 'false'
     	/>
		<div class="allll">
			全部安徽律师
		</div>
     </div>
      <div class="between zhuanye">
        <lay-item-win
          style="width: 222px; height: 314px"
          v-for="(item, index) in list"
          :consult-or-more="true"
          :key="index"
		  :item = 'item'
        ></lay-item-win>
      </div>
    </div>
</template>

<script>
import layItemWin from "../components/layItemWin";
import secTitle from "../components/secTitle";
export default {
  components: {
    secTitle,
    layItemWin,
	
  },
  data(){
	  return{
		  list:[]
	  }
  },
  created() {
  	this.$http.home.lawyerads({
  		ad_id:14,
  		limit:4
  	}).then( res => {
  		this.list = res.data.data
  	})
  }
};
</script>

<style lang="scss" scoped>
  .major_lawyer {
    width: 1200px;
	height: auto;
    margin: 0 auto;
    padding: 50px 0;
	.allll{
		width: 152px;
		height: 36px;
		border: 1px solid #222222;
		font-size: 22px;
		font-weight: 400;
		color: #222222;
		line-height: 36px;
		text-align: center;
	}
  }
</style>